exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.DeviceSWAnalysisPage .DebounceInputFilter input, .DeviceSWAnalysisPage .DebounceInputFilter label {\n  font-size: 15px;\n}\n\n.DeviceSWAnalysisPage .SimpleTimeRangeFilter select, .DeviceSWAnalysisPage .SimpleTimeRangeFilter label {\n  font-size: 15px;\n}", ""]);

// exports
